import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const response = await axios.get(`http://3.109.108.187/api/gallery`);
      setImages(response.data);
    } catch (error) {
      console.error('Error fetching gallery images:', error);
    } finally {
      setLoading(false);
    }
  };

  const placeholderImages = [
    'https://images.unsplash.com/photo-1703045199207-5312874d9e54',
    'https://images.unsplash.com/photo-1645694413160-fddc7f0feb5d',
    'https://images.unsplash.com/photo-1558380366-faa32a1c7f9f',
    'https://images.unsplash.com/photo-1600955800300-5beffd81f099',
    'https://images.unsplash.com/photo-1687709644312-8c67bd4821c6',
    'https://images.unsplash.com/photo-1724436781032-c1645c5783ef',
    'https://images.unsplash.com/flagged/photo-1580408453889-ed5e1b51924a',
    'https://images.unsplash.com/photo-1703045199207-5312874d9e54'
  ];

  const displayImages = images.length > 0 ? images : placeholderImages.map((url, index) => ({
    id: `placeholder-${index}`,
    title: `Event Moment ${index + 1}`,
    image_url: url,
    description: 'Amrut Mahotsav Celebration'
  }));

  return (
    <div className="min-h-screen bg-white" data-testid="gallery-page">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[300px] mt-20" data-testid="gallery-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-green-600"></div>
        <div className="relative h-full flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">Gallery</h1>
            <p className="text-xl text-white/90">Moments from our 75-year journey</p>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="section-spacing" data-testid="gallery-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="text-center py-20">
              <div className="inline-block w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
              <p className="mt-4 text-gray-600">Loading gallery...</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {displayImages.map((image, index) => (
                <div
                  key={image.id}
                  className="gallery-item aspect-square cursor-pointer"
                  onClick={() => setSelectedImage(image)}
                  data-testid={`gallery-item-${index}`}
                >
                 <img
                  src={`http://3.109.108.187/assets/${image.image_url}`}
                  alt={image.title}
                  className="rounded-xl"
                />
                  <div className="overlay">
                    <div>
                      <p className="text-white font-semibold text-lg">{image.title}</p>
                      {image.description && (
                        <p className="text-white/80 text-sm mt-1">{image.description}</p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
          data-testid="gallery-modal"
        >
          <div className="relative max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setSelectedImage(null)}
              data-testid="gallery-modal-close"
              className="absolute -top-12 right-0 text-white hover:text-orange-400 text-xl font-bold"
            >
              ✕ Close
            </button>
            <img
              src={`http://3.109.108.187/assets/${selectedImage.image_url}`}
              alt={selectedImage.title}
              className="w-full h-auto rounded-lg"
            />
            <div className="mt-4 text-white text-center">
              <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
              {selectedImage.description && (
                <p className="text-gray-300">{selectedImage.description}</p>
              )}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Gallery;